var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976",
    transform: "translate(0.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(-0.2 0)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-pop-up-2186785",
    transform: "translate(6.38 6.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M317.305,53.015h-5.08v-5.08a1.27,1.27,0,0,0-2.54,0v5.08H304.6a1.27,1.27,0,0,0,0,2.54h5.08v5.08a1.27,1.27,0,0,0,2.54,0v-5.08h5.08a1.27,1.27,0,0,0,0-2.54Z",
    transform: "translate(-303.335 -46.665)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8e5afe85d6bcc944c2990175f00065cf.svg";
export { ForwardRef as ReactComponent };